export { selectUnit } from './src/diff';
export { defaultNumberOption, getInternalSlot, getMultiInternalSlots, getNumberOption, getOption, isLiteralPart, partitionPattern, setInternalSlot, setMultiInternalSlots, setNumberFormatDigitOptions, toObject, objectIs, isWellFormedCurrencyCode, toString, formatNumericToString, toRawFixed, toRawPrecision, getMagnitude, repeat, hasOwnProperty, isWellFormedUnitIdentifier, defineProperty, } from './src/polyfill-utils';
export { createResolveLocale, getLocaleHierarchy, supportedLocales, unpackData, isMissingLocaleDataError, } from './src/resolve-locale';
export * from './src/units';
export * from './src/relative-time-types';
export * from './src/list-types';
export * from './src/plural-rules-types';
export * from './src/number-types';
export * from './src/displaynames-types';
export { invariant } from './src/invariant';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formatjs/intl-utils/lib/index.js
// module id = 141
// module chunks = 43